import { AuthState } from '@okta/okta-auth-js';

import { CommissionRateMassDeletes } from '../../services/backend/CommissionRateMassDeletes';
import { useBaseApiClient } from '../useBaseApiClient';

export const useCommissionRateMassDeletes: () => CommissionRateMassDeletes<AuthState> = () => {
  return useBaseApiClient(CommissionRateMassDeletes);
};
